import React from "react";
import Button from "../buttons/Button";
import {useDispatch, useSelector} from "react-redux";
import Image from "../theme/Image";
import {addErrorAlert, openGetUserRightsByPinModal, setTransactionUser} from "../redux/actions";
import {getHasRightToMakeDiscount} from "../redux/selectors";

const validateSupervisor = (title, dispatch, state, onSuccess, onFail, onClose) => {
    dispatch(openGetUserRightsByPinModal(dispatch, state.rootReducer.user.clientCode, state.rootReducer.posID, ((userRights, supervisor) => {
        if(getHasRightToMakeDiscount(userRights)){
            dispatch(setTransactionUser(supervisor));
            onSuccess();
        }else{
            dispatch(addErrorAlert('User has no right to perform this action!'));
            onFail();
        }
    }), onClose, true, title));
}
export default function ({title, confirmText, onConfirm, cancelText, onCancel}) {
    const theme = useSelector(state => state.rootReducer.theme);
    const dispatch = useDispatch();
    const state = useSelector(state => state);

    const doConfirm = () => {
        if(window.AppConf.productRemoveSupervisor){
            validateSupervisor('Remove product', dispatch, state, () => {
                onConfirm();
            }, onCancel, onCancel);
        }else{
            onConfirm();
        }
    }

    let cancelButton;
    if(typeof cancelText !== "undefined"){
        if(theme === 'Decathlon'){
            cancelButton = (
                <div className={"dialogueConfirmButton"} onClick={onCancel}>
                    <Button type="button" className={"largeButton grayButton"} name={cancelText}
                            arrow="right" flencheClass={"flencheSmallRightBottom grayFlenche"}/>
                </div>
            )
        }else{
            cancelButton = (
                <div className={"dialogueConfirmButton"} onClick={onCancel}>
                    <Button
                        type="button"
                        className={"button largerButton grayButton roundButton uppercaseText"}
                        name={cancelText}
                        arrow="left"
                    />
                </div>
            )
        }
    }

    let confirmButton;
    if(theme === 'Decathlon'){
        confirmButton = (
            <div className={"dialogueConfirmButton"} onClick={doConfirm}>
                <Button type="button" className={"largeButton blueButton negativeActionButton"} name={confirmText}
                        arrow="right" flencheClass={"flencheSmallRightBottom blueFlenche"}/>
            </div>
        );
    }else{
        confirmButton = (
            <div className={"dialogueConfirmButton"} onClick={doConfirm}>
                <Button type="button"
                        className={"button largerButton lightBlueButton roundButton uppercaseText"}
                        name={confirmText}
                        arrow="right"
                />
            </div>
        );
    }

    return (
        <div style={{
            textAlign:"center",
            position: "absolute",
            top: 0,
            bottom: "8.57rem",
            left: 0,
            right: 0
        }}>
            <div style={{
                display: "table",
                height: "100%",
                width: "100%"
            }}>
                <div style={{
                    display: "table-cell",
                    verticalAlign: "middle"
                }}>
                <span className={"boldUppercaseText"}>
                    {title}
                </span>
                    <br/>
                    <div style={{
                        "marginBottom": "1.43rem"
                    }}/>
                        <Image image={"removeProducts"} alt={"removeProducts"} style={{width: theme === 'Decathlon' ? 300 : 200}}/>
                    <br/>
                    <div style={{
                        "marginBottom": "3.57rem"
                    }}/>
                </div>
            </div>
            <div className={"dialogueConfirmButtons"}>
                {cancelButton}
                {confirmButton}
            </div>
        </div>
    );
}
